(ns rothko.theme.manatee.colours
  (:require [garden.color :as color :refer [rgb rgba]]
            [rothko.styles.vars.common :as common]))

(def colours
  (merge
   common/colours
   {:blue-dark (rgb 22 109 128)
    :blue-light (rgb 80 195 202)
    :audio-level-green (rgb 112 249 63)
    :audio-level-red (rgb 247 28 28)
    :audio-level-yellow (rgb 243 235 45)
    :green (rgb 34 188 155)
    :grey-dark (rgb 100 98 101)
    :grey-bg-gradient-dark (rgba 198 200 207 0.4)
    :grey-bg-gradient-light (rgb 241 241 243)
    :purple (rgb 72 66 115)
    :red (rgb 234 107 107)
    :red-dark (rgb 169 68 66)
    :red-light (rgba 169 68 66 0.2)
    :red-bright "red"}))

(def editor
  {:yellow (rgb 237 255 13)
   :green (rgb 25 255 38)
   :dark-green (rgb 168 194 86)
   :orange (rgb 255 140 0)
   :purple (rgb 141 0 255)
   :magenta (rgb 255 13 111)})
